import { toCamelCaseObj } from '@/utils/transformers';
import { MasterDataEndpoints, masterDataFetcher } from './fetchers';

export async function shortenUrl(long_url: string) {
  const response = await masterDataFetcher.post(
    MasterDataEndpoints.shortenUrl,
    { long_url },
  );
  return toCamelCaseObj(response.data.data);
}
